import mixins from '@synergycms_core/less/mixins.js';

export default {

    noDispoModalContent: {
        '& $modalTabsList':{
            height:'100%'
        }
    },
    closeButton: {},
    headerModal: {
        '& ~ div':{
            height:'100%',
            '& > div:nth-of-type(1)':{
                position:'sticky',
                top:'49px',
                zIndex:5
            },
            '& > div:nth-of-type(2)':{
                height:'100%',
            }
        }
    },
    modalTitle: {},
    modalTabsList: {},
    noDispoModal: {
        position: 'fixed',
        left: '0',
        right: '0',
        top: '0',
        bottom: '100%',
        height: '100%',
        background: '#fff',
        zIndex: '600',
        overflow: 'auto',
        ...mixins.transition('bottom 1s'),
        padding:'0',
        '& $noDispoModalContent': {
            height:'100%',
            '& $closeButton': {
                top: '13px',
                right: '14px',
                position: 'fixed',
                zIndex: '99999',
                background: 'none',
                cursor: 'pointer',
                color: data => data.mainColor,
                border: '0',
                fontSize: '15px',
                '&:lang(ar)':{
                    right: "auto",
                    left: "14px",
                },
            },
            '& $headerModal': {
                border: '1px solid #d8d8d8',
                padding: '11px 50px 14px 20px',
                textAlign: 'left',
                zIndex: '10',
                background: '#fff',
                position:'sticky',
                top:0,
                '& span': {
                    font: "400 18px 'Droid Serif'"
                },
                '&:lang(ar)': {
                    paddingLeft: "50px",
                    paddingRight: "20px",
                    textAlign: "right"
                }
            },
        },
        '& > div':{
            height:'100%',
            '& > div':{
                height:'100%',
            }
        }
    },
    calendarSvg:{
        marginRight: '5px',
        verticalAlign: 'sub',
    }
};